/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchLogBatchFilterData = (data) => ({
  type: actionTypes.GET_LOG_BATCH_FILTER_DATA,
  filterData: data,
});

export const dispatchCheckPayeeList = (data) => ({
  type: actionTypes.GET_CHECK_PAYEE_LIST,
  checkPayee: data,
});

export const dispatchLogCheckDetails = (data) => ({
  type: actionTypes.GET_LOG_NUMBER_DETAILS,
  logCheckDetails: data,
});

export const dispatchLogBatchTotalList = (data) => ({
  type: actionTypes.GET_LOG_BATCH_TOTAL_LIST,
  logBatchList: data,
});

export const dispatchLogBatchTotalSelectedListDetail = (data) => ({
  type: actionTypes.GET_LOG_BATCH_TOTAL_DETAIL,
  logBatchDetail: data,
});

export const handleErrorMessages = (data) => ({
  type: actionTypes.HANDLE_ERROR_MSG,
  errorMessagesInRedux: data,
});

export const setDetailScreenObj = (data) => ({
  type: actionTypes.DETAIL_SCREEN_OBJ,
  detailScreenObj: data,
});
export const dispatchSaveAPI = (data) => ({
  type: actionTypes.SAVE_STATUS,
  saveStatus: data,
});

export const handleSaveAPI = async (values) => {
  try {
    const response = await axios.post(serviceEndPoint.SAVE_LG_CHK, values);

    if (response.data && response.data.data && response.data.data.length > 0) {
      return response;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const checkBatchNumber = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.CHECK_BATCH_NUMBER,
      values
    );
    if (response && response.data) {
      return response.data;
    }
    return null;
  } catch (e) {
    return null;
  }
};
export const searchNDCByIDORDrugName = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.SEARCH_NDC_BY_ID_OR_DRUG_NAME,
      values
    );

    if (response.data && response.data.data && response.data.data.length > 0) {
      return response;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const dispatchViewHistoryforPlan = (data) => ({
  type: actionTypes.GET_LOG_BATCH_TOTAL_HISTORY,
  logBatchHistory: data,
});

export const saveLogBatchFilterData = (value) => (dispatch) => {
  dispatch(dispatchLogBatchFilterData(value));
};

export const getCheckPayeeList = (value) => {
  return axios
    .post(serviceEndPoint.SYSTEM_LIST_DROPDOWN, value)
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return [];
    });
};

export const getLogCheckDetails = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.LOG_CHK_DETAILS, value)
    .then((response) => {
      return dispatch(dispatchLogCheckDetails(response.data));
    })
    .catch((response) => {
      dispatch(dispatchLogCheckDetails([]));
    });
};

export const getLogBatchTotalList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.LOG_BATCH_TOTAL_LIST, value)
    .then((response) => {
      const list = response?.data;
      list?.data?.length > 0 &&
        (list?.data).forEach((elem) => {
          elem.totCheckAmt = elem?.totCheckAmt.toString().replace('$', '');
          if (elem?.cfFrozen == '1') {
            elem.cfFrozen = '0';
          } else if (elem?.cfFrozen == '0') {
            elem.cfFrozen = '1';
          }
        });
      return dispatch(dispatchLogBatchTotalList(list));
    })
    .catch((response) => {
      dispatch(dispatchLogBatchTotalList([]));
    });
};

export const setLogBatchTotalSelectListDetail = (value) => (dispatch) => {
  return dispatch(dispatchLogBatchTotalSelectedListDetail(value));
};

export const getLogBatchHistory = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.VIEW_HISTORY}`, values)
    .then((response) => {
      return dispatch(
        dispatchViewHistoryforPlan(
          response.data && response.data.responseAuditLogDetails
        )
      );
    })
    .catch(() => {
      dispatch(dispatchViewHistoryforPlan([]));
    });
};
export const clearReduxForLogBatchFirstScreen = () => (dispatch) => {
  dispatch(dispatchLogBatchTotalList([]));
  dispatch(setLogBatchTotalSelectListDetail([]));
  dispatch(handleErrorMessages({}));
  dispatch(
    dispatchLogBatchFilterData({
      batchInCompleteStatus: 'I',
      isFilter: true,
      batchesForPayee: '-1',
      filterBatchesBy: 'noFilter',
    })
  );
};
export const clearReduxForLogBatchSecondScreen = () => (dispatch) => {
  dispatch(setLogBatchTotalSelectListDetail([]));
  dispatch(getLogBatchHistory());
  dispatch(getLogCheckDetails([]));
  dispatch(dispatchLogCheckDetails({}));
  dispatch(dispatchLogBatchTotalSelectedListDetail({}));
  dispatch(handleErrorMessages({}));
  dispatch(dispatchLogBatchTotalList([]));
};
